// Выбор темы: тёмная, светлая или по системе.
//
// Раньше тема была прибита к тёмной одной строкой в applyTelegramTheme, а
// светлые токены лежали мёртвым грузом. Теперь предпочтение хранится у
// пользователя, а тёмная остаётся значением по умолчанию — это основной вид
// приложения, а не ночной режим.

export type ThemePref = 'dark' | 'light' | 'system';
export type Scheme = 'dark' | 'light';

const KEY = 'rl_theme';

/** Фон под схему — продублирован из --paper в styles.css: CSS-переменные не
    дотягиваются до шапки и фона самого клиента Telegram. */
export const THEME_BG: Record<Scheme, string> = {
  light: '#F7F4EE',
  dark: '#121310',
};

export function loadThemePref(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    /* приватный режим или заблокированные куки — работаем на дефолте */
  }
  return 'dark';
}

export function saveThemePref(p: ThemePref): void {
  try {
    localStorage.setItem(KEY, p);
  } catch {
    /* не смогли запомнить — тема всё равно применится на эту сессию */
  }
}

/** Во что разворачивается «по системе» прямо сейчас. */
export function systemScheme(): Scheme {
  try {
    return matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function resolveScheme(p: ThemePref): Scheme {
  return p === 'system' ? systemScheme() : p;
}

/**
 * Применить схему к документу.
 *
 * Переключение темы меняет цвет, фон, обводку и тень почти у каждого элемента
 * разом. Если оставить переходы включёнными, они сработают все вместе и смена
 * «размазывается» вместо того, чтобы щёлкнуть. Поэтому переходы глушатся на
 * один кадр: вставляем правило, заставляем пересчёт, снимаем на следующем кадре.
 */
export function applyScheme(pref: ThemePref): Scheme {
  const scheme = resolveScheme(pref);
  const root = document.documentElement;
  if (root.dataset.scheme === scheme) return scheme;

  const style = document.createElement('style');
  style.textContent = '*,*::before,*::after{transition:none !important}';
  document.head.appendChild(style);
  root.dataset.scheme = scheme;
  // Чтение layout-свойства заставляет браузер применить новые стили сразу,
  // до того как мы вернём переходы.
  void root.offsetHeight;
  requestAnimationFrame(() => style.remove());
  return scheme;
}
